import { ReportStatus, Status } from "graphql/types"

export const getTextForStatus = (status: Status) => {
  switch (status) {
    case Status.OPEN:
      return "Offen"
    case Status.IN_PROGRESS:
      return "In Prüfung"
    case Status.DONE:
      return "Abgeschlossen"
    case Status.PAUSED:
      return "Pausiert"
    case Status.BILLED:
      return "Abgerechnet"
    default:
      return status
  }
}

export const getTextForReportStatus = (status: ReportStatus) => {
  switch (status) {
    case ReportStatus.DONE:
      return "Abgeschlossen"
    case ReportStatus.DRAFT:
      return "Entwurf"
    default:
      return status
  }
}

export const getColorForStatus = (status: Status) => {
  switch (status) {
    case Status.OPEN:
      return "primary"
    case Status.IN_PROGRESS:
      return "info"
    case Status.DONE:
      return "success"
    default:
      return "primary"
  }
}
